import { combineReducers } from 'redux';
import {
 MAPPING_CONTAINER_GET_SUCCESS, MAPPING_CONTAINER_MODAL,
 ADD_MAPPING_CONTAINER_GET_SUCCESS,EDIT_MAPPING_CONTAINER_GET_SUCCESS,
 MAPPING_LIST_CONTAINER_GET_SUCCESS
} from '../actions/mappingContainerAction';

const mappingContainer = (state = {isLoad:false, value:[], msg:''} , action) => {
  switch (action.type) {
    case MAPPING_CONTAINER_GET_SUCCESS:
      return {value:action.val, isLoad:action.load,  msg:action.msg}
    default:
      return state
  }
}
const mappingListContainer = (state = {isLoad:false, value:[], msg:''} , action) => {
  switch (action.type) {
    case MAPPING_LIST_CONTAINER_GET_SUCCESS:
      return {value:action.val, isLoad:action.load,  msg:action.msg}
    default:
      return state
  }
}
const containerModal = (state = {show:false, value:{}} , action) => {
  switch (action.type) {
    case MAPPING_CONTAINER_MODAL:
      return {show:action.show, value:action.value}
    default:
      return state
  }
}
const addMappingContainer = (state = {isLoad:false, value:false, msg:''} , action) => {
  switch (action.type) {
    case ADD_MAPPING_CONTAINER_GET_SUCCESS:
      return {value:action.val, isLoad:action.load,  msg:action.msg}
    default:
      return state
  }
}
const editMappingContainer = (state = {isLoad:false, value:false, msg:''} , action) => {
  switch (action.type) {
    case EDIT_MAPPING_CONTAINER_GET_SUCCESS:
      return {value:action.val, isLoad:action.load,  msg:action.msg}
    default:
      return state
  }
}
const MappingContainerReducer = combineReducers({
  mappingContainer,
  mappingListContainer,
  containerModal,
  addMappingContainer,
  editMappingContainer,
})

export default MappingContainerReducer